import React from "react";
import "./Import.css";

// Contacts one batch row wrote to (or skipped on) its lead, from
// GET /import/batches/{id} → leads[].contacts (built server-side from the exact
// payload that was sent to Iris — see contact_append.row_contacts).

export function contactCounts(rows) {
	let added = 0;
	let skipped = 0;
	for (const r of rows || []) {
		for (const c of r.contacts || []) {
			if (c.status === "added") added += 1;
			else if (c.status === "skipped") skipped += 1;
		}
	}
	return { added, skipped };
}

// Compact cell: "2 added · 1 skipped" style summary with a toggle.
export function ContactsCell({ contacts, open, onToggle }) {
	const list = contacts || [];
	if (list.length === 0) return <span className="importMuted">—</span>;
	const added = list.filter((c) => c.status === "added").length;
	const skipped = list.filter((c) => c.status === "skipped").length;
	const planned = list.filter((c) => c.status === "planned").length;
	const parts = [];
	if (added) parts.push(`${added} added`);
	if (skipped) parts.push(`${skipped} skipped`);
	if (planned) parts.push(`${planned} planned`);
	return (
		<button type="button" className={`contactToggle ${open ? "open" : ""}`} onClick={onToggle}>
			<span className="contactCaret" aria-hidden="true">
				▸
			</span>
			{parts.join(" · ")}
		</button>
	);
}

function Line({ c }) {
	const details = [c.email, c.phone, c.title].filter(Boolean);
	return (
		<li className={`contactCard ${c.status}`}>
			<div className="contactTop">
				<span className="contactName">{c.name || c.email || "(no name)"}</span>
				{c.primary && <span className="contactBadge primary">Primary</span>}
				{c.status === "added" && c.record ? (
					<span className="contactBadge">contact #{c.record}</span>
				) : null}
				{c.status === "skipped" && <span className="contactBadge skipped">skipped</span>}
				{c.status === "planned" && <span className="contactBadge">not run yet</span>}
			</div>
			{details.length > 0 && <div className="contactMeta">{details.join(" · ")}</div>}
			{c.reason && <div className="contactReason">{c.reason}</div>}
		</li>
	);
}

export function ContactList({ contacts }) {
	return (
		<ul className="contactList">
			{(contacts || []).map((c, i) => (
				<Line key={`${c.record ?? "s"}-${i}`} c={c} />
			))}
		</ul>
	);
}
